const actions = {
  SET_STATE: 'countdownTimer/SET_STATE',
  CHANGE_ENTITY_VALUE: 'countdownTimer/CHANGE_ENTITY_VALUE',
  RENDER_FUND_INFO: 'countdownTimer/RENDER_FUND_INFO',
}

export default actions